import { api, getSessionIdFromLocalStorage } from "../common/utils"
import { APIError } from "../types"

const ENDPOINT_UPLOAD_IMAGE_S3 = "/api/v1/s3-file-upload"
const ENDPOINT_UPLOAD_IMAGE_BB = "/bb-file-upload.json"

type UploadImageResult = { etag?: string; filename: string; url: string }

const asset = {
  uploadImage: async (
    file: File,
    filename: string,
    useS3: boolean = true
  ): Promise<UploadImageResult | APIError> => {
    const form = new FormData()
    form.append("files[img]", file)

    if (useS3) {
      const { data } = await api.post(ENDPOINT_UPLOAD_IMAGE_S3, form)
      return data
    }

    const bbSid = getSessionIdFromLocalStorage()
    const endpoint = `${ENDPOINT_UPLOAD_IMAGE_BB}${
      bbSid ? `?bb_sid=${bbSid}` : ""
    }`
    const { data } = await api.post(endpoint, form)

    // BB response shape: { message: { fid, filename, url } }
    if (data?.message?.url) {
      return {
        filename: data.message.filename ?? filename,
        url: data.message.url
      }
    }
    return data
  }
}

export default asset
